export var AddressUploadResultState;
(function (AddressUploadResultState) {
    AddressUploadResultState["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    AddressUploadResultState["ADDRESS_ALREADY_IN_DATABASE"] = "ADDRESS_ALREADY_IN_DATABASE";
    AddressUploadResultState["ERROR"] = "ERROR";
})(AddressUploadResultState || (AddressUploadResultState = {}));
